"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ASFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_13)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_13`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-12 0H24V24H-12V0Z",
					fill: "#10338C"
				}),
				/* @__PURE__ */ n("path", {
					d: "M24 2.31579L-5.31228 12L24 21.8077V24L-12 12L24 0V2.31579Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M24 20.1529V21.8779L-6.26526 12L24 2.10522V3.80066",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.4723 9.83929L19.9362 10.5888L19.713 9.51368L21.9018 7.42456C21.9018 7.42456 21.2407 4.57193 20.9369 4.26807L13.0548 8.18526L12.5748 10.7649L10.3362 12.7712L10.3081 15.1712L12.7144 13.574L17.4323 13.3874L17.3263 16.0618H18.8864L19.7214 12.9291L21.9355 11.2021L21.4723 9.83929Z",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.308 16.7304L8.74731 15.9508L10.308 15.1711H20.4456V16.7304H10.308Z",
					fill: "#EFC100",
					stroke: "#231F20",
					strokeWidth: .0701754,
					strokeMiterlimit: 10
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_13`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ASFlag };
